export interface Address {
    uid: string | null;
    name: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    state: string | null;
    postalCode: number | null;
}

export class Address {
    constructor(data: Partial<Address> = {},) {
        this.uid = data.uid ? data.uid : null;
        this.name = data.name ? data.name : null;
        this.addressLine1 = data.addressLine1 ? data.addressLine1 : null;
        this.addressLine2 = data.addressLine2 ? data.addressLine2 : null;
        this.city = data.city ? data.city : null;
        this.state = data.state ? data.state : null;
        this.postalCode = data.postalCode ? data.postalCode : null;
    }
}

export interface ShipmentAddresses {
    pickUp: Address;
    deliverTo: Address;
}

